import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './RfiQuestion.css';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import SimpleTruncate from 'components/shared/text/SimpleTruncate';
import Dropdown from 'components/shared/dropdown/Dropdown';
import TextareaAutosize from 'react-autosize-textarea';
import SearchableDropDownPaginated from 'components/shared/dropdown/SearchableDropDownPaginated';
import LabeledCheckBox from 'components/shared/checkbox/LabeledCheckBox';
import { usersUtil, ROLES } from 'services/utils/users-util';
import { Enterprise } from 'domain/enterprise';
import RfiDocuments from 'components/admin/projects/details/project-rfi-log/RfiDocuments';
import RfiResponse from 'components/admin/projects/details/project-rfi-log/RfiResponse';
import RfiQuestionNotes from 'components/admin/projects/details/project-rfi-log/RfiQuestionNotes';
import RfiAddlAssignees from 'components/admin/projects/details/project-rfi-log/RfiAddlAssignees';

class RfiQuestion extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({}).isRequired,
    contribType: PropTypes.string.isRequired,
    dueDate: PropTypes.string,
    questionKey: PropTypes.string.isRequired,
    question: PropTypes.shape({}).isRequired,
    assigneeChanged: PropTypes.func.isRequired,
    resolvedChanged: PropTypes.func.isRequired,
    loadContributors: PropTypes.func.isRequired,
    loadQuestionNotes: PropTypes.func.isRequired,
    createQuestionNote: PropTypes.func.isRequired,
    handleQuestionChange: PropTypes.func.isRequired,
    handleQuestionDeleteFile: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    modalReadOnly: PropTypes.bool,
    gcAcceleration: PropTypes.bool,
  };

  assigneeExists = (userId) => {
    return this.props.question.assignee[0] === userId;
  };

  render() {
    const {
      contribType,
      currentUser,
      dueDate,
      questionKey,
      question,
      loadQuestionNotes,
      createQuestionNote,
      handleQuestionChange,
      handleQuestionDeleteFile,
      assigneeChanged,
      resolvedChanged,
      loadContributors,
      readOnly,
      modalReadOnly,
      gcAcceleration,
    } = this.props;
    const spackleOrGc =
      Enterprise.spackleOrGc(contribType) &&
      !usersUtil.hasRole(currentUser, ROLES.GENERAL_CONTRACTOR_SUPERINTENDENT);

    return (
      <tr className="rfi-question">
        <td>
          <span className="question-number">{question.number}</span>
        </td>
        <td>
          <Row>
            <Col sm={7}>
              {(readOnly || spackleOrGc) && (
                <Row className="question-assignee">
                  <Col sm={1} componentClass={ControlLabel}>
                    {readOnly ? 'Assigned To' : 'Assign To'}
                  </Col>
                  <Col sm={8}>
                    {question.assignee.length === 0 ? (
                      readOnly ? (
                        '-'
                      ) : (
                        <div
                          className={classnames({
                            'contributor-add': true,
                            'question-error': question.errors.assignee,
                          })}
                        >
                          <div className="add-row-plus">+</div>
                          <SearchableDropDownPaginated
                            loadOptions={loadContributors}
                            onChange={(option) => {
                              if (!this.assigneeExists(option.value)) {
                                handleQuestionChange(questionKey, 'assignee', [
                                  option.value,
                                  option.label,
                                ]);
                                assigneeChanged(questionKey);
                              }
                            }}
                            placeholder="Add Contributor"
                          />
                        </div>
                      )
                    ) : (
                      <div
                        className="contributor-selected"
                        onClick={() => {
                          if (!readOnly && spackleOrGc) {
                            handleQuestionChange(questionKey, 'assignee', []);
                          }
                        }}
                      >
                        {!readOnly && spackleOrGc && (
                          <span className="remove">X</span>
                        )}
                        <span>{question.assignee[1]}</span>
                      </div>
                    )}
                  </Col>
                </Row>
              )}

              {(readOnly || spackleOrGc) && (
                <Row>
                  <Col componentClass={ControlLabel} sm={1}>
                    Additional Assignees
                  </Col>
                  <Col sm={8}>
                    <RfiAddlAssignees
                      contribType={contribType}
                      dueDate={dueDate}
                      question={question}
                      questionKey={questionKey}
                      readOnly={readOnly}
                    />
                  </Col>
                </Row>
              )}

              <Row>
                <Col
                  componentClass={ControlLabel}
                  sm={1}
                  className="action-label"
                >
                  Action
                </Col>
                <Col sm={8}>
                  {readOnly ? (
                    <span className="action-value">{question.action}</span>
                  ) : (
                    <Dropdown
                      className={classnames({
                        'action-value': true,
                        'question-error': question.errors.action,
                      })}
                      placeholder="Select Action..."
                      value={question.action}
                      onChange={(option) =>
                        handleQuestionChange(
                          questionKey,
                          'action',
                          option.value
                        )
                      }
                      options={[
                        { value: 'Question', label: 'Question' },
                        { value: 'Confirm Receipt', label: 'Confirm Receipt' },
                        {
                          value: 'Approval Request',
                          label: 'Approval Request',
                        },
                      ]}
                    />
                  )}
                </Col>
              </Row>

              <Row>
                <Col componentClass={ControlLabel} sm={1}>
                  Question
                </Col>
                <Col sm={8}>
                  {readOnly ? (
                    <SimpleTruncate text={question.question} />
                  ) : (
                    <TextareaAutosize
                      className={classnames({
                        'question-error': question.errors.question,
                      })}
                      rows={1}
                      placeholder="Enter Question Here…"
                      defaultValue={question.question}
                      onBlur={(e) =>
                        handleQuestionChange(
                          questionKey,
                          'question',
                          e.target.value
                        )
                      }
                    />
                  )}
                </Col>
              </Row>

              <RfiDocuments
                questionKey={questionKey}
                question={question}
                readOnly={readOnly}
                fileType="req"
                handleQuestionChange={handleQuestionChange}
                handleQuestionDeleteFile={handleQuestionDeleteFile}
              />

              <hr />

              <RfiResponse
                questionKey={questionKey}
                question={question}
                currentUser={currentUser}
                contribType={contribType}
                readOnly={modalReadOnly}
                gcAcceleration={gcAcceleration}
                handleResponseChange={handleQuestionChange}
                handleQuestionDeleteFile={handleQuestionDeleteFile}
              />

              {(question.responded_at || gcAcceleration) && (
                <Row>
                  <Col sm={1}></Col>
                  <Col sm={8}>
                    <LabeledCheckBox
                      checked={!!question.resolved}
                      onChange={(value) => {
                        handleQuestionChange(questionKey, 'resolved', value);
                        resolvedChanged(questionKey);
                      }}
                      label="Resolved"
                      readOnly={
                        readOnly || Enterprise.subcontractor(contribType)
                      }
                    />
                  </Col>
                </Row>
              )}
            </Col>

            <Col sm={5}>
              {question.id && (
                <RfiQuestionNotes
                  questionKey={questionKey}
                  question={question}
                  loadQuestionNotes={loadQuestionNotes}
                  createQuestionNote={createQuestionNote}
                />
              )}
            </Col>
          </Row>
        </td>
      </tr>
    );
  }
}

export default connect()(RfiQuestion);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-rfi-log/RfiQuestion.js